<div class="grid__row">
	<div class="grid__col--10 grid__col-offset--1">
		<div [innerHtml]="cmsResult.mainContent"></div>
	</div>
</div>